<template>
  <div class="main_wrap d-grid align-items-start">
    <div class="account_menu">
      <nav class="nav_area">
        <ul class="nav_list list-unstyled mb-0">
          <li>
            <input id="nav_01" type="checkbox" class="nav_ipt d-none" checked disabled>
            <label class="nav_title d-flex nav_lab mb-0" for="nav_01" />
            <div class="nav_content">
              <span>
                <ul class="nav_inner list-unstyled">
                  <li class="mt-0 pt-0">
                    <a v-if="$store.getters.memberInfo" href="#" class="nav_member d-flex align-items-center p-0">
                      <img
                        class="rounded-circle mw-100"
                        :src="$store.getters.memberInfo.image"
                        width="60"
                        height="60"
                      >
                      <div class="nav_member_inner">
                        <h6 class="">{{ $t('Bao.nickname') }}</h6>
                        <h5 class="mb-0">{{ $store.getters.memberInfo.nickname }}</h5>
                      </div>
                    </a>
                    <a v-else class="nav_member d-flex align-items-center p-0">
                      <div class="nav_member_inner">
                        <h6 class="">{{ $t('Bao.nickname') }}</h6>
                        <h5 class="mb-0">{{ $t('Bao.welcome_you') }}</h5>
                      </div>
                    </a>
                  </li>
                </ul>
                <ul class="nav_account nav_inner list-unstyled">
                  <li>
                    <div class="nav_account_wrap d-grid">
                      <div class="nav_account_info">
                        <div class="nav_account_title d-flex align-items-center">
                          <img class="mw-100 mr-5" src="@/assets/images/upload/img_wallet_nav.svg" width="16" height="16" alt="">
                          <span class="white_space">{{ $t('Bao.wallet_balance') }}</span>
                        </div>
                        <h5 v-if="$store.getters.memberInfo" class="nav_account_money text-center mb-0">
                          <!-- eslint-disable -->
                            <span v-html="$options.filters['numberFormat']($store.getters.gold)" />
                        </h5>
                        <h5 class="nav_account_money text-center mb-0" v-else>
                        </h5>
                      </div>
                      <div class="sub_member_btn d-grid">
                        <router-link
                            tag="button"
                            class="btn btn_stored_value text-white"
                            to="/payment/deposit"
                        >
                            {{ $t('Bao.deposit') }}
                        </router-link>
                        <router-link
                            tag="button"
                            class="btn btn_withdraw text-white"
                            to="/payment/withdrawal"
                        >
                            {{ $t('Bao.withdrawal') }}
                        </router-link>
                      </div>
                    </div>
                  </li>
                </ul>
                <ul class="nav_inner list-unstyled">
                    <li>
                    <router-link class="align-items-center" to="/user">
                        <img
                        class="mw-100"
                        :src="getMenuIcon('img_left_nav_person')"
                        alt=""
                        width="16"
                        height="16"
                        >
                        <img
                        class="mw-100"
                        :src="getMenuIcon('img_left_nav_person_hover')"
                        alt=""
                        width="16"
                        height="16"
                        >
                        <span class="white_space">{{ $t('Bao.personal') }}</span>
                    </router-link>
                    </li>
                    <li>
                    <router-link class="align-items-center" to="/wallet">
                        <img
                        class="mw-100"
                        :src="getMenuIcon('img_left_nav_money')"
                        alt=""
                        width="16"
                        height="16"
                        >
                        <img
                        class="mw-100"
                        :src="getMenuIcon('img_left_nav_money_hover')"
                        alt=""
                        width="16"
                        height="16"
                        >
                        <span class="white_space">{{ $t('Bao.wallet_center') }}</span>
                    </router-link>
                    </li>
                    <li>
                    <router-link class="align-items-center" to="/transaction">
                        <img
                        class="mw-100"
                        :src="getMenuIcon('img_left_nav_detail')"
                        alt=""
                        width="16"
                        height="16"
                        >
                        <img
                        class="mw-100"
                        :src="getMenuIcon('img_left_nav_detail_hover')"
                        alt=""
                        width="16"
                        height="16"
                        >
                        <span class="white_space">{{ $t('Bao.transaction-index') }}</span>
                    </router-link>
                    </li>
                    <li>
                    <router-link class="align-items-center" to="/game/bet">
                        <img
                        class="mw-100"
                        :src="getMenuIcon('img_left_nav_bet')"
                        alt=""
                        width="16"
                        height="16"
                        >
                        <img
                        class="mw-100"
                        :src="getMenuIcon('img_left_nav_bet_hover')"
                        alt=""
                        width="16"
                        height="16"
                        >
                        <span class="white_space">{{ $t('Bao.game-bet-index') }}</span>
                    </router-link>
                    </li>
                </ul>
                <ul class="nav_inner list-unstyled">
                    <li>
                    <router-link class="align-items-center" to="/event/me">
                        <img
                        class="mw-100"
                        :src="getMenuIcon('img_left_nav_bonus')"
                        alt=""
                        width="16"
                        height="16"
                        >
                        <img
                        class="mw-100"
                        :src="getMenuIcon('img_left_nav_bonus_hover')"
                        alt=""
                        width="16"
                        height="16"
                        >
                        <span class="white_space">{{ $t('Bao.event-me') }}</span>
                    </router-link>
                    </li>
                    <li>
                    <router-link class="align-items-center" to="/event">
                        <img
                        class="mw-100"
                        :src="getMenuIcon('img_left_nav_sale')"
                        alt=""
                        width="16"
                        height="16"
                        >
                        <img
                        class="mw-100"
                        :src="getMenuIcon('img_left_nav_sale_hover')"
                        alt=""
                        width="16"
                        height="16"
                        >
                        <span class="white_space">{{ $t('Bao.event-index') }}</span>
                    </router-link>
                    </li>
                </ul>
                <ul class="nav_inner list-unstyled">
                    <li>
                    <router-link class="align-items-center" to="/user/letter">
                        <img
                        class="mw-100"
                        :src="getMenuIcon('img_left_nav_notify')"
                        alt=""
                        width="16"
                        height="16"
                        >
                        <img
                        class="mw-100"
                        :src="getMenuIcon('img_left_nav_notify_hover')"
                        alt=""
                        width="16"
                        height="16"
                        >
                        <span class="white_space">{{ $t('Bao.letter-index') }}</span>
                    </router-link>
                    </li>
                    <li>
                    <router-link class="align-items-center" to="/bank">
                        <img
                        class="mw-100"
                        :src="getMenuIcon('img_left_nav_bank')"
                        alt=""
                        width="16"
                        height="16"
                        >
                        <img
                        class="mw-100"
                        :src="getMenuIcon('img_left_nav_bank_hover')"
                        alt=""
                        width="16"
                        height="16"
                        >
                        <span class="white_space">{{ $t('Bao.bank_card') }}</span>
                    </router-link>
                    </li>
                </ul>
                <ul class="nav_inner list-unstyled">
                    <li>
                    <router-link class="align-items-center" to="/user/vip">
                        <img
                        class="mw-100"
                        :src="getMenuIcon('img_left_nav_vip')"
                        alt=""
                        width="16"
                        height="16"
                        >
                        <img
                        class="mw-100"
                        :src="getMenuIcon('img_left_nav_vip_hover')"
                        alt=""
                        width="16"
                        height="16"
                        >
                        <span class="white_space">VIP</span>
                    </router-link>
                    </li>
                    <li>
                    <router-link class="align-items-center" to="/user/friend">
                        <img
                        class="mw-100"
                        :src="getMenuIcon('img_left_nav_recommend')"
                        alt=""
                        width="16"
                        height="16"
                        >
                        <img
                        class="mw-100"
                        :src="getMenuIcon('img_left_nav_recommend_hover')"
                        alt=""
                        width="16"
                        height="16"
                        >
                        <span class="white_space">{{ $t('Bao.user-friend') }}</span>
                    </router-link>
                    </li>
                    <!-- <li v-if="$store.getters.memberInfo && $store.getters.memberInfo.member_type != 0">
                    <a target="_blank" :href="$store.getters.urlInfo.agentUrl" class="align-items-center">
                        <img
                        class="mw-100"
                        :src="getMenuIcon('img_left_nav_cooperate')"
                        alt=""
                        width="16"
                        height="16"
                        >
                        <img
                        class="mw-100"
                        :src="getMenuIcon('img_left_nav_cooperate_hover')"
                        alt=""
                        width="16"
                        height="16"
                        >
                        <span class="white_space">{{ $t('Bao.agent_login') }}</span>
                    </a>
                    </li> -->
                    <!-- <li v-if="$store.getters.memberInfo === null">
                    <router-link class="align-items-center" to="/agent">
                        <img
                        class="mw-100"
                        :src="getMenuIcon('img_left_nav_cooperate')"
                        alt=""
                        width="16"
                        height="16"
                        >
                        <img
                        class="mw-100"
                        :src="getMenuIcon('img_left_nav_cooperate_hover')"
                        alt=""
                        width="16"
                        height="16"
                        >
                        <span class="white_space">{{ $t('Bao.agent_apply') }}</span>
                    </router-link>
                    </li> -->
                </ul>
                </span>
            </div>
          </li>
        </ul>
      </nav>
    </div>
    <transition name="fade" mode="out-in">
    <router-view />
    </transition>
  </div>
</template>

<script>

export default {
  methods: {
    getMenuIcon(name) {
      return require('@/assets/' + this.$store.getters.brand.theme + '/images/upload/' + name + '.svg')
    },
    getMenuIconHover(name) {
      return require('@/assets/' + this.$store.getters.brand.theme + '/images/upload/' + name + '_hover.svg')
    }
  }
}
</script>
